import { Link } from "@remix-run/react";

import styles from "./MoreWaysToPlayButtons.module.scss";

const platformToIconMap = new Map([
	["Android", "/images/icons/icon-android.svg"],
	["Samsung", "/images/icons/icon-samsung.svg"],
	["iOS / iPad", "/images/icons/icon-apple.svg"],
	["Epic Games Store", "/images/icons/icon-epicgames.svg"],
]);

export default function MoreWaysToPlayButtons({
	links,
}: {
	links: { title: string; href: string }[];
}): React.ReactNode {
	return (
		<div className={`column is-full p-0 m-0 ${styles.modalButtons}`}>
			{links.map((link) => (
				<Link key={link.title} to={link.href}>
					<button className={styles.modalButton} name={link.title}>
						<span>{link.title}</span>
						<img src={platformToIconMap.get(link.title)} width="16px" height="16px" alt={link.title} />
					</button>
				</Link>
			))}
		</div>
	);
}
